<template>
  <div class="row">
    <div class="col-lg-8 inline">
      <h4>
        <h2 style="display: inline">Analytics | &nbsp;</h2>
        Select Time:
        <el-select
          class="select-info tab select-width"
          placeholder="Single Select"
          v-model="selects.selectTime"
          @change="getTimeSeriesData()"
        >
          <el-option
            v-for="option in selects.timeSeries"
            class="select-info"
            :value="option.value"
            :label="option.label"
            :key="option.label"
          ></el-option>
        </el-select>
      </h4>
    </div>
    <div class="col-lg-4 style-date">
      <span class="demonstration">Select Date Range</span>
      <el-date-picker
        v-model="selectDate"
        type="daterange"
        range-separator="To"
        start-placeholder="Start date"
        end-placeholder="End date"
        @change="getAllDataOnRange()"
      ></el-date-picker>
    </div>

    <div class="col-lg-12">
      <div class="row">
        <div class="col">
          <h4>
            Select Customer:
            <el-select
              class="select-info tab select-width"
              placeholder="Single Select"
              v-model="selects.selectCustomer"
              @change="filterCustomer()"
            >
              <el-option
                v-for="option in selects.customer"
                class="select-info"
                :value="option.value"
                :label="option.label"
                :key="option.label"
              ></el-option>
            </el-select>
          </h4>
        </div>
        <div class="col">
          <h4>
            Select Region:
            <el-select
              class="select-info tab select-width"
              placeholder="Single Select"
              :disabled="disableRegion"
              v-model="selects.selectRegion"
              @change="filterRegion()"
            >
              <el-option
                v-for="option in selects.region"
                class="select-info"
                :value="option.value"
                :label="option.label"
                :key="option.label"
              ></el-option>
            </el-select>
          </h4>
        </div>
        <div class="col">
          <h4>
            Select Route:
            <el-select
              class="select-info tab select-width"
              placeholder="Single Select"
              :disabled="disableRoute"
              v-model="selects.selectRoute"
              @change="filterRoute()"
            >
              <el-option
                v-for="option in selects.route"
                class="select-info"
                :value="option.value"
                :label="option.label"
                :key="option.label"
              ></el-option>
            </el-select>
          </h4>
        </div>
        <div class="col">
          <h4>
            Select Driver:
            <el-select
              class="select-info tab select-width"
              placeholder="Single Select"
              :disabled="disableDriver"
              v-model="selects.selectDriver"
              @change="filterDriver()"
            >
              <el-option
                v-for="option in selects.driver"
                class="select-info"
                :value="option.value"
                :label="option.label"
                :key="option.label"
              ></el-option>
            </el-select>
          </h4>
        </div>
      </div>
    </div>
    <div class="col-lg-12">
      <hr />
    </div>
    <div class="col-lg-12">
      <card class="chart">
        <template slot="header">
          <h5 class="card-category">
            <b>Weekly</b>
          </h5>
          <h3 class="card-title">
            <i class="tim-icons icon-chart-bar-32 text-info"></i>
            <b>&nbsp;Efficiency of Frequency</b>
          </h3>
        </template>
        <div class="chart-area">
          <bar-chart
            v-if="efficiencyFrequency.loaded"
            :chart-data="efficiencyFrequency.chartData"
            :extra-options="efficiencyFrequency.extraOptions"
            :gradient-colors="efficiencyFrequency.gradientColors"
            :gradient-stops="efficiencyFrequency.gradientStops"
            :height="300"
          ></bar-chart>
          <div
            class="d-flex justify-content-center spinner"
            v-if="!efficiencyFrequency.loaded"
          >
            <circle-8></circle-8>
          </div>
        </div>
      </card>
    </div>
    <div class="col-lg-4">
      <card type="card-chart">
        <template slot="header">
          <h5 class="card-category">
            <b>Weekly</b>
          </h5>
          <h3 class="card-title">
            <i class="tim-icons icon-chart-bar-32 text-info"></i>
            <b>&nbsp;Performance Percentage</b>
          </h3>
        </template>
        <div class="chart-area">
          <bar-chart
            v-if="performancePercentage.loaded"
            :chart-data="performancePercentage.chartData"
            :extra-options="performancePercentage.extraOptions"
            :gradient-colors="performancePercentage.gradientColors"
            :gradient-stops="performancePercentage.gradientStops"
            :height="245"
          ></bar-chart>
          <div
            class="d-flex justify-content-center spinner"
            v-if="!performancePercentage.loaded"
          >
            <circle-8></circle-8>
          </div>
        </div>
      </card>
    </div>
    <div class="col-lg-4">
      <card type="card-chart">
        <template slot="header">
          <h5 class="card-category">
            <b>Weekly</b>
          </h5>
          <h3 class="card-title">
            <i class="tim-icons icon-chart-bar-32 text-info"></i>
            <b>&nbsp;Collection Punctuality</b>
          </h3>
        </template>
        <div class="chart-area">
          <line-chart
            v-if="collectionPunctuality.loaded"
            :chart-data="collectionPunctuality.chartData"
            :gradient-colors="collectionPunctuality.gradientColors"
            :gradient-stops="collectionPunctuality.gradientStops"
            :extra-options="collectionPunctuality.extraOptions"
            :height="245"
          ></line-chart>
          <div
            class="d-flex justify-content-center spinner"
            v-if="!collectionPunctuality.loaded"
          >
            <circle-8></circle-8>
          </div>
        </div>
      </card>
    </div>
    <div class="col-lg-4">
      <card class="chart">
        <template slot="header">
          <h5 class="card-category">
            <b>Weekly</b>
          </h5>
          <h3 class="card-title">
            <i class="tim-icons icon-chart-bar-32 text-info"></i>
            <b>&nbsp;Customer Rating</b>
          </h3>
        </template>
        <div class="chart-area">
          <bar-chart
            v-if="barChart2.loaded"
            :chart-data="barChart2.chartData"
            :extra-options="barChart2.extraOptions"
            :gradient-colors="barChart2.gradientColors"
            :gradient-stops="barChart2.gradientStops"
            :height="245"
          ></bar-chart>
          <div
            class="d-flex justify-content-center spinner"
            v-if="!barChart2.loaded"
          >
            <circle-8></circle-8>
          </div>
        </div>
      </card>
    </div>
  </div>
</template>
<script>
import LineChart from "@/components/Charts/LineChart";
import BarChart from "@/components/Charts/BarChart";
import * as chartConfigs from "@/components/Charts/config";
import config from "@/config";
import { Select, Option, DatePicker } from "element-ui";

import axios from "axios";
import moment from "moment";
import swal from "sweetalert2";
import { Circle8 } from "vue-loading-spinner";

export default {
  components: {
    LineChart,
    BarChart,
    [Select.name]: Select,
    [Option.name]: Option,
    [DatePicker.name]: DatePicker,
    Circle8,
  },
  data() {
    return {
      // Selecting interval data
      selects: {
        selectCustomer: "",
        selectRegion: "",
        selectRoute: "",
        selectDriver: "",
        selectTime: "",
        timeSeries: [
          { value: "Today", label: "Today" },
          { value: "Weekly", label: "Weekly" },
          { value: "Monthly", label: "Monthly" },
        ],
        customer: [{ value: "All", label: "All" }],
        region: [{ value: "All", label: "All" }],
        route: [{ value: "All", label: "All" }],
        driver: [{ value: "All", label: "All" }],
      },
      disableRegion: true,
      disableRoute: true,
      disableDriver: true,
      selectDate: "",
      customerLogs: null,
      regionLogs: null,
      routeLogs: null,
      driverLogs: null,
      custPunctuality: null,
      regionPunctuality: null,
      routePunctuality: null,
      driverPunctuality: null,
      labels: null,
      // Two Line Chart
      collectionPunctuality: {
        chartData: {
          labels: ["MON", "TUE", "WED", "THU", "FRI", "SAT", "SUN"],
          datasets: [
            {
              label: "On Time",
              fill: true,
              borderColor: "rgba(37, 67, 117, 1)",
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              pointBackgroundColor: "rgba(37, 67, 117, 1)",
              pointBorderColor: "rgba(255,255,255,0)",
              pointHoverBackgroundColor: "#be55ed",
              pointBorderWidth: 20,
              pointHoverRadius: 4,
              pointHoverBorderWidth: 15,
              pointRadius: 4,
              data: [150, 150, 150, 150, 150, 150, 150],
            },
            {
              label: "Late",
              fill: true,
              borderColor: "rgba(255, 3, 2, 1)",
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              pointBackgroundColor: "rgba(255, 3, 2, 1)",
              pointBorderColor: "rgba(255,255,255,0)",
              pointHoverBackgroundColor: "#be55ed",
              pointBorderWidth: 20,
              pointHoverRadius: 4,
              pointHoverBorderWidth: 15,
              pointRadius: 4,
              data: [110, 130, 90, 98, 105, 110, 130],
            },
          ],
        },
        extraOptions: chartConfigs.purpleChartOptions,
        gradientColors: [
          "rgba(37, 67, 117, 0.5)",
          "rgba(37, 67, 117, 0.0)",
          "rgba(37, 67, 117, 0.0)",
          "rgba(255, 3, 2, 0.8)",
          "rgba(255, 3, 2, 0.2)",
          "rgba(255, 3, 2, 0.0)",
        ],
        gradientStops: [1, 0.4, 0, 1, 0.4, 0],
        loaded: false,
      },
      efficiencyFrequency: {
        chartData: {
          labels: ["MON", "TUE", "WED", "THU", "FRI", "SAT", "SUN"],
          datasets: [
            {
              label: "Actual",
              fill: true,
              borderColor: "rgba(37, 67, 117, 1)",
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              data: [80, 100, 70, 80, 120, 80, 120],
            },
            {
              type: "line",
              label: "Schedule",
              fill: false,
              borderColor: "rgba(237, 28, 36, 1)",
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              pointBackgroundColor: "rgba(237, 28, 36, 1)",
              pointBorderColor: "rgba(255,255,255,0)",
              pointHoverBackgroundColor: config.colors.danger,
              pointBorderWidth: 20,
              pointHoverRadius: 4,
              pointHoverBorderWidth: 15,
              pointRadius: 4,
              data: [120, 120, 120, 120, 120, 120, 120],
            },
          ],
        },
        loaded: false,
        extraOptions: chartConfigs.barChartOptionsGradient,
        gradientColors: [
          "rgba(37, 67, 117, 0.9)",
          "rgba(37, 67, 117, 0.3)",
          "rgba(255,255,255, 0)",
        ],
        gradientStops: [1, 0],
      },
      performancePercentage: {
        chartData: {
          labels: ["MON", "TUE", "WED", "THU", "FRI", "SAT", "SUN"],
          datasets: [
            {
              label: "%Number of Pickup",
              fill: true,
              borderColor: "rgba(255, 3, 2, 1)",
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              data: [80, 70, 90, 85, 75, 81, 69],
            },
          ],
        },
        loaded: false,
        extraOptions: chartConfigs.percentageBarChart,
        gradientColors: [
          "rgba(255, 3, 2, 0.8)",
          "rgba(255, 3, 2, 0.2)",
          "rgba(255, 3, 2, 0.1)",
        ],
        gradientStops: [1, 0],
      },
      barChart2: {
        chartData: {
          labels: ["1 Star", "2 Star", "3 Star", "4 Star", "5 Star"],
          datasets: [
            {
              label: "Rating",
              fill: true,
              borderColor: "rgba(255, 3, 2, 1)",
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              data: [1, 2, 3, 4, 5],
            },
          ],
        },
        loaded: false,
        extraOptions: chartConfigs.barChartOptionsGradient,
        gradientColors: [
          "rgba(255, 3, 2, 0.8)",
          "rgba(255, 3, 2, 0.2)",
          "rgba(255, 3, 2, 0.1)",
        ],
        gradientStops: [1, 0],
      },

      // customer rating
      rating: [],
      // punctuality
      punctuality: [],
    };
  },
  methods: {
    //////////////////////////////////////////////////////// FILTER CUSTOMER ///////////////////////////////////////////////////////////
    async filterCustomer() {
      if (this.customerLogs == null) return;
      this.efficiencyFrequency.loaded = false;
      this.performancePercentage.loaded = false;
      this.barChart2.loaded = false;
      this.collectionPunctuality.loaded = false;
      const CUSTOMER = await this.selects.selectCustomer;

      if (CUSTOMER != "All") {
        /////////////////////////////////////////////DZAF////////////////////////////////////////////////////////////////////////////
        let actualData = null;
        let scheduleData = null;

        // Find the selected filter
        for (let i = 0; i < this.customerLogs.length; i++) {
          if (CUSTOMER == this.customerLogs[i].CustName) {
            actualData = this.customerLogs[i].CollectionLog;
            scheduleData = this.customerLogs[i].ScheduleData;
          }
        }

        this.efficiencyFrequency.chartData.datasets[0].data = actualData;
        this.efficiencyFrequency.chartData.datasets[1].data = scheduleData;

        // Marshalling for Performance Perentage
        let percentageData = [];
        for (let i = 0; i < scheduleData.length; i++) {
          let percent = (actualData[i] / scheduleData[i]) * 100;
          percentageData.push(percent.toFixed(2));
        }
        // Update Performance Percentage
        this.performancePercentage.chartData.datasets[0].data = percentageData;

        // Storing regions filter
        this.selects.region = [{ value: "All", label: "All" }];
        for (let i = 0; i < this.regionLogs.length; i++) {
          if (CUSTOMER == this.regionLogs[i].CustName) {
            let record = {};
            record["value"] = this.regionLogs[i].RegionName;
            record["label"] = this.regionLogs[i].RegionName;
            this.selects.region.push(record);
          }
        }

        // ################################################################################################# //

        // Customer Punctuality
        let onTime = Array(this.labels.length).fill(0);
        let late = Array(this.labels.length).fill(0);

        for (let i = 0; i < this.custPunctuality.length; i++) {
          if (CUSTOMER == this.custPunctuality[i].CustName) {
            for (let j = 0; j < this.custPunctuality[i].OnTime.length; j++) {
              onTime[j] += this.custPunctuality[i].OnTime[j];
            }
            for (let j = 0; j < this.custPunctuality[i].Late.length; j++) {
              late[j] += this.custPunctuality[i].Late[j];
            }
          }
        }

        this.collectionPunctuality = {
          chartData: {
            labels: this.labels,
            datasets: [
              {
                label: "On Time",
                fill: true,
                borderColor: "rgba(37, 67, 117, 1)",
                borderWidth: 2,
                borderDash: [],
                borderDashOffset: 0.0,
                pointBackgroundColor: "rgba(37, 67, 117, 1)",
                pointBorderColor: "rgba(255,255,255,0)",
                pointHoverBackgroundColor: "#be55ed",
                pointBorderWidth: 20,
                pointHoverRadius: 4,
                pointHoverBorderWidth: 15,
                pointRadius: 4,
                data: onTime,
              },
              {
                label: "Late",
                fill: true,
                borderColor: "rgba(255, 3, 2, 1)",
                borderWidth: 2,
                borderDash: [],
                borderDashOffset: 0.0,
                pointBackgroundColor: "rgba(255, 3, 2, 1)",
                pointBorderColor: "rgba(255,255,255,0)",
                pointHoverBackgroundColor: "#be55ed",
                pointBorderWidth: 20,
                pointHoverRadius: 4,
                pointHoverBorderWidth: 15,
                pointRadius: 4,
                data: late,
              },
            ],
          },
          extraOptions: chartConfigs.purpleChartOptions,
          gradientColors: [
            "rgba(37, 67, 117, 0.5)",
            "rgba(37, 67, 117, 0.0)",
            "rgba(37, 67, 117, 0.0)",
            "rgba(255, 3, 2, 0.8)",
            "rgba(255, 3, 2, 0.2)",
            "rgba(255, 3, 2, 0.0)",
          ],
          gradientStops: [1, 0.4, 0, 1, 0.4, 0],
          loaded: false,
        };

        ///////////////////////////////////AMIRAH////////////////////////////////////////////////
        let customerRating = [];

        // customer rating
        for (var i = 0; i < this.rating.length; i++) {
          if (CUSTOMER === this.rating[i].CustName) {
            customerRating = [
              parseInt(this.rating[i].Star1),
              parseInt(this.rating[i].Star2),
              parseInt(this.rating[i].Star3),
              parseInt(this.rating[i].Star4),
              parseInt(this.rating[i].Star5),
            ];
            this.barChart2.chartData.datasets[0].data = customerRating;
          }
        }
      } else {
        ////////////////////////////////////DZAF/////////////////////////////////////////////////
        let scheduleData = [];
        let actualData = [];

        // Store all Customer schedule
        let schedule = [];
        for (let i = 0; i < this.customerLogs.length; i++) {
          schedule.push(this.customerLogs[i].ScheduleData);
        }
        // Calculation for Schedule
        for (let i = 0; i < schedule[0].length; i++) {
          let total = 0;
          for (let j = 0; j < schedule.length; j++) {
            total += schedule[j][i];
          }
          scheduleData.push(total);
        }

        // Store all Customer actual pickup
        let actual = [];
        for (let i = 0; i < this.customerLogs.length; i++) {
          actual.push(this.customerLogs[i].CollectionLog);
        }
        // Calculation for Actual
        for (let i = 0; i < actual[0].length; i++) {
          let total = 0;
          for (let j = 0; j < actual.length; j++) {
            total += parseInt(actual[j][i]);
          }
          actualData.push(total);
        }

        // Marshalling for Performance Perentage
        let percentageData = [];
        for (let i = 0; i < scheduleData.length; i++) {
          let percent = (actualData[i] / scheduleData[i]) * 100;
          percentageData.push(percent.toFixed(2));
        }

        // ################################################################################################# //

        // Customer Punctuality
        let onTime = Array(this.labels.length).fill(0);
        let late = Array(this.labels.length).fill(0);

        console.log(onTime);
        console.log(late);

        for (let i = 0; i < this.routePunctuality.length; i++) {
          for (let j = 0; j < this.routePunctuality[i].OnTime.length; j++) {
            onTime[j] += this.routePunctuality[i].OnTime[j];
          }
          for (let j = 0; j < this.routePunctuality[i].Late.length; j++) {
            late[j] += this.routePunctuality[i].Late[j];
          }
        }

        this.collectionPunctuality = {
          chartData: {
            labels: this.labels,
            datasets: [
              {
                label: "On Time",
                fill: true,
                borderColor: "rgba(37, 67, 117, 1)",
                borderWidth: 2,
                borderDash: [],
                borderDashOffset: 0.0,
                pointBackgroundColor: "rgba(37, 67, 117, 1)",
                pointBorderColor: "rgba(255,255,255,0)",
                pointHoverBackgroundColor: "#be55ed",
                pointBorderWidth: 20,
                pointHoverRadius: 4,
                pointHoverBorderWidth: 15,
                pointRadius: 4,
                data: onTime,
              },
              {
                label: "Late",
                fill: true,
                borderColor: "rgba(255, 3, 2, 1)",
                borderWidth: 2,
                borderDash: [],
                borderDashOffset: 0.0,
                pointBackgroundColor: "rgba(255, 3, 2, 1)",
                pointBorderColor: "rgba(255,255,255,0)",
                pointHoverBackgroundColor: "#be55ed",
                pointBorderWidth: 20,
                pointHoverRadius: 4,
                pointHoverBorderWidth: 15,
                pointRadius: 4,
                data: late,
              },
            ],
          },
          extraOptions: chartConfigs.purpleChartOptions,
          gradientColors: [
            "rgba(37, 67, 117, 0.5)",
            "rgba(37, 67, 117, 0.0)",
            "rgba(37, 67, 117, 0.0)",
            "rgba(255, 3, 2, 0.8)",
            "rgba(255, 3, 2, 0.2)",
            "rgba(255, 3, 2, 0.0)",
          ],
          gradientStops: [1, 0.4, 0, 1, 0.4, 0],
          loaded: false,
        };

        // ################################################################################################# //

        // Update Performance Percentage
        this.performancePercentage.chartData.datasets[0].data = percentageData;

        // Update Efficiency Frequency Graph
        this.efficiencyFrequency.chartData.datasets[1].data = scheduleData;
        this.efficiencyFrequency.chartData.datasets[0].data = actualData;

        // Storing regions filter
        this.selects.region = [{ value: "All", label: "All" }];
        for (let i = 0; i < this.regionLogs.length; i++) {
          if (CUSTOMER == this.regionLogs[i].CustName) {
            let record = {};
            record["value"] = this.regionLogs[i].RegionName;
            record["label"] = this.regionLogs[i].RegionName;
            this.selects.region.push(record);
          }
        }

        /////////////////////////////////////////AMIRAH//////////////////////////////////////////
        let customerRating = [];

        // customer rating for all customer
        var SumStar1 = 0;
        var SumStar2 = 0;
        var SumStar3 = 0;
        var SumStar4 = 0;
        var SumStar5 = 0;

        for (var i = 0; i < this.rating.length; i++) {
          SumStar1 += Number(this.rating[i].Star1);
          SumStar2 += Number(this.rating[i].Star2);
          SumStar3 += Number(this.rating[i].Star3);
          SumStar4 += Number(this.rating[i].Star4);
          SumStar5 += Number(this.rating[i].Star5);

          customerRating = [SumStar1, SumStar2, SumStar3, SumStar4, SumStar5];
          this.barChart2.chartData.datasets[0].data = customerRating;
        }
      }

      this.selects.selectDriver = "";
      this.selects.selectRoute = "";
      this.selects.selectRegion = "";
      this.disableDriver = true;
      this.disableRoute = true;
      this.disableRegion = false;
      CUSTOMER == "All"
        ? (this.disableRegion = true)
        : (this.disableRegion = false);
      this.performancePercentage.loaded = true;
      this.efficiencyFrequency.loaded = true;
      this.barChart2.loaded = true;
      this.collectionPunctuality.loaded = true;
    },
    //////////////////////////////////////////////////////// FILTER REGION ///////////////////////////////////////////////////////////
    async filterRegion() {
      this.efficiencyFrequency.loaded = false;
      this.performancePercentage.loaded = false;
      this.collectionPunctuality.loaded = false;

      const REGION = await this.selects.selectRegion;
      const CUSTOMER = this.selects.selectCustomer;

      if (REGION != "All") {
        let actualData = null;
        let scheduleData = null;
        // Find the selected filter
        for (let i = 0; i < this.regionLogs.length; i++) {
          if (
            REGION == this.regionLogs[i].RegionName &&
            CUSTOMER == this.regionLogs[i].CustName
          ) {
            actualData = this.regionLogs[i].CollectionLog;
            scheduleData = this.regionLogs[i].ScheduleData;
            this.efficiencyFrequency.chartData.datasets[0].data = actualData;
            this.efficiencyFrequency.chartData.datasets[1].data = scheduleData;
          }
        }

        // Marshalling for Performance Perentage
        let percentageData = [];
        for (let i = 0; i < scheduleData.length; i++) {
          let percent = (actualData[i] / scheduleData[i]) * 100;
          percentageData.push(percent.toFixed(2));
        }
        // Update Performance Percentage
        this.performancePercentage.chartData.datasets[0].data = percentageData;

        // ################################################################################################# //

        // Customer Punctuality
        let onTime = Array(this.labels.length).fill(0);
        let late = Array(this.labels.length).fill(0);

        for (let i = 0; i < this.regionPunctuality.length; i++) {
          if (
            CUSTOMER == this.regionPunctuality[i].CustName &&
            REGION == this.regionPunctuality[i].RegionName
          ) {
            for (let j = 0; j < this.regionPunctuality[i].OnTime.length; j++) {
              onTime[j] += this.regionPunctuality[i].OnTime[j];
            }
            for (let j = 0; j < this.regionPunctuality[i].Late.length; j++) {
              late[j] += this.regionPunctuality[i].Late[j];
            }
          }
        }

        this.collectionPunctuality = {
          chartData: {
            labels: this.labels,
            datasets: [
              {
                label: "On Time",
                fill: true,
                borderColor: "rgba(37, 67, 117, 1)",
                borderWidth: 2,
                borderDash: [],
                borderDashOffset: 0.0,
                pointBackgroundColor: "rgba(37, 67, 117, 1)",
                pointBorderColor: "rgba(255,255,255,0)",
                pointHoverBackgroundColor: "#be55ed",
                pointBorderWidth: 20,
                pointHoverRadius: 4,
                pointHoverBorderWidth: 15,
                pointRadius: 4,
                data: onTime,
              },
              {
                label: "Late",
                fill: true,
                borderColor: "rgba(255, 3, 2, 1)",
                borderWidth: 2,
                borderDash: [],
                borderDashOffset: 0.0,
                pointBackgroundColor: "rgba(255, 3, 2, 1)",
                pointBorderColor: "rgba(255,255,255,0)",
                pointHoverBackgroundColor: "#be55ed",
                pointBorderWidth: 20,
                pointHoverRadius: 4,
                pointHoverBorderWidth: 15,
                pointRadius: 4,
                data: late,
              },
            ],
          },
          extraOptions: chartConfigs.purpleChartOptions,
          gradientColors: [
            "rgba(37, 67, 117, 0.5)",
            "rgba(37, 67, 117, 0.0)",
            "rgba(37, 67, 117, 0.0)",
            "rgba(255, 3, 2, 0.8)",
            "rgba(255, 3, 2, 0.2)",
            "rgba(255, 3, 2, 0.0)",
          ],
          gradientStops: [1, 0.4, 0, 1, 0.4, 0],
          loaded: false,
        };

        // ################################################################################################# //

        // Storing routes filter
        this.selects.route = [{ value: "All", label: "All" }];
        for (let i = 0; i < this.routeLogs.length; i++) {
          if (
            REGION == this.routeLogs[i].RegionName &&
            CUSTOMER == this.routeLogs[i].CustName
          ) {
            let record = {};
            record["value"] = this.routeLogs[i].RouteName;
            record["label"] = this.routeLogs[i].RouteName;
            this.selects.route.push(record);
          }
        }
      } else {
        let scheduleData = [];
        let actualData = [];

        // Store all Customer schedule
        let schedule = [];
        for (let i = 0; i < this.regionLogs.length; i++) {
          if (CUSTOMER == this.regionLogs[i].CustName) {
            schedule.push(this.regionLogs[i].ScheduleData);
          }
        }
        // Calculation for Schedule
        for (let i = 0; i < schedule[0].length; i++) {
          let total = 0;
          for (let j = 0; j < schedule.length; j++) {
            total += schedule[j][i];
          }
          scheduleData.push(total);
        }

        // Store all Customer actual pickup
        let actual = [];
        for (let i = 0; i < this.regionLogs.length; i++) {
          if (CUSTOMER == this.regionLogs[i].CustName) {
            actual.push(this.regionLogs[i].CollectionLog);
          }
        }
        // Calculation for Actual
        for (let i = 0; i < actual[0].length; i++) {
          let total = 0;
          for (let j = 0; j < actual.length; j++) {
            total += parseInt(actual[j][i]);
          }
          actualData.push(total);
        }

        // Marshalling for Performance Perentage
        let percentageData = [];
        for (let i = 0; i < scheduleData.length; i++) {
          let percent = (actualData[i] / scheduleData[i]) * 100;
          percentageData.push(percent.toFixed(2));
        }

        // ################################################################################################# //

        // Customer Punctuality
        let onTime = Array(this.labels.length).fill(0);
        let late = Array(this.labels.length).fill(0);

        for (let i = 0; i < this.routePunctuality.length; i++) {
          if (CUSTOMER == this.routePunctuality[i].CustName) {
            for (let j = 0; j < this.routePunctuality[i].OnTime.length; j++) {
              onTime[j] += this.routePunctuality[i].OnTime[j];
            }
            for (let j = 0; j < this.routePunctuality[i].Late.length; j++) {
              late[j] += this.routePunctuality[i].Late[j];
            }
          }
        }

        this.collectionPunctuality = {
          chartData: {
            labels: this.labels,
            datasets: [
              {
                label: "On Time",
                fill: true,
                borderColor: "rgba(37, 67, 117, 1)",
                borderWidth: 2,
                borderDash: [],
                borderDashOffset: 0.0,
                pointBackgroundColor: "rgba(37, 67, 117, 1)",
                pointBorderColor: "rgba(255,255,255,0)",
                pointHoverBackgroundColor: "#be55ed",
                pointBorderWidth: 20,
                pointHoverRadius: 4,
                pointHoverBorderWidth: 15,
                pointRadius: 4,
                data: onTime,
              },
              {
                label: "Late",
                fill: true,
                borderColor: "rgba(255, 3, 2, 1)",
                borderWidth: 2,
                borderDash: [],
                borderDashOffset: 0.0,
                pointBackgroundColor: "rgba(255, 3, 2, 1)",
                pointBorderColor: "rgba(255,255,255,0)",
                pointHoverBackgroundColor: "#be55ed",
                pointBorderWidth: 20,
                pointHoverRadius: 4,
                pointHoverBorderWidth: 15,
                pointRadius: 4,
                data: late,
              },
            ],
          },
          extraOptions: chartConfigs.purpleChartOptions,
          gradientColors: [
            "rgba(37, 67, 117, 0.5)",
            "rgba(37, 67, 117, 0.0)",
            "rgba(37, 67, 117, 0.0)",
            "rgba(255, 3, 2, 0.8)",
            "rgba(255, 3, 2, 0.2)",
            "rgba(255, 3, 2, 0.0)",
          ],
          gradientStops: [1, 0.4, 0, 1, 0.4, 0],
          loaded: false,
        };

        // ################################################################################################# //

        // Update Performance Percentage
        this.performancePercentage.chartData.datasets[0].data = percentageData;

        // Update Efficiency Frequency Graph
        this.efficiencyFrequency.chartData.datasets[1].data = scheduleData;
        this.efficiencyFrequency.chartData.datasets[0].data = actualData;

        // Storing regions filter
        this.selects.route = [{ value: "All", label: "All" }];
        for (let i = 0; i < this.routeLogs.length; i++) {
          if (REGION == this.routeLogs[i].CustName) {
            let record = {};
            record["value"] = this.routeLogs[i].RouteName;
            record["label"] = this.routeLogs[i].RegionName;
            this.selects.route.push(record);
          }
        }
      }
      this.selects.selectDriver = "";
      this.selects.selectRoute = "";
      this.disableDriver = true;
      this.disableRoute = false;
      REGION == "All"
        ? (this.disableRoute = true)
        : (this.disableRoute = false);
      this.performancePercentage.loaded = true;
      this.efficiencyFrequency.loaded = true;
      this.collectionPunctuality.loaded = true;
    },
    //////////////////////////////////////////////////////// FILTER ROUTE ///////////////////////////////////////////////////////////
    async filterRoute() {
      this.efficiencyFrequency.loaded = false;
      this.performancePercentage.loaded = false;
      this.collectionPunctuality.loaded = false;

      const ROUTE = await this.selects.selectRoute;
      const REGION = this.selects.selectRegion;
      const CUSTOMER = this.selects.selectCustomer;

      if (ROUTE != "All") {
        let scheduleData = null;
        let actualData = null;

        // Find the selected filter
        for (let i = 0; i < this.routeLogs.length; i++) {
          if (
            CUSTOMER == this.routeLogs[i].CustName &&
            REGION == this.routeLogs[i].RegionName &&
            ROUTE == this.routeLogs[i].RouteName
          ) {
            actualData = this.routeLogs[i].CollectionLog;
            scheduleData = this.routeLogs[i].ScheduleData;
            this.efficiencyFrequency.chartData.datasets[0].data = actualData;
            this.efficiencyFrequency.chartData.datasets[1].data = scheduleData;
          }
        }

        // Marshalling for Performance Perentage
        let percentageData = [];
        for (let i = 0; i < scheduleData.length; i++) {
          let percent = (actualData[i] / scheduleData[i]) * 100;
          percentageData.push(percent.toFixed(2));
        }

        // Update Performance Percentage
        this.performancePercentage.chartData.datasets[0].data = percentageData;

        // ################################################################################################# //

        // Customer Punctuality
        let onTime = Array(this.labels.length).fill(0);
        let late = Array(this.labels.length).fill(0);

        for (let i = 0; i < this.routePunctuality.length; i++) {
          if (
            CUSTOMER == this.routePunctuality[i].CustName &&
            REGION == this.routePunctuality[i].RegionName &&
            ROUTE == this.routePunctuality[i].RouteName
          ) {
            for (let j = 0; j < this.routePunctuality[i].OnTime.length; j++) {
              onTime[j] += this.routePunctuality[i].OnTime[j];
            }
            for (let j = 0; j < this.routePunctuality[i].Late.length; j++) {
              late[j] += this.routePunctuality[i].Late[j];
            }
          }
        }

        this.collectionPunctuality = {
          chartData: {
            labels: this.labels,
            datasets: [
              {
                label: "On Time",
                fill: true,
                borderColor: "rgba(37, 67, 117, 1)",
                borderWidth: 2,
                borderDash: [],
                borderDashOffset: 0.0,
                pointBackgroundColor: "rgba(37, 67, 117, 1)",
                pointBorderColor: "rgba(255,255,255,0)",
                pointHoverBackgroundColor: "#be55ed",
                pointBorderWidth: 20,
                pointHoverRadius: 4,
                pointHoverBorderWidth: 15,
                pointRadius: 4,
                data: onTime,
              },
              {
                label: "Late",
                fill: true,
                borderColor: "rgba(255, 3, 2, 1)",
                borderWidth: 2,
                borderDash: [],
                borderDashOffset: 0.0,
                pointBackgroundColor: "rgba(255, 3, 2, 1)",
                pointBorderColor: "rgba(255,255,255,0)",
                pointHoverBackgroundColor: "#be55ed",
                pointBorderWidth: 20,
                pointHoverRadius: 4,
                pointHoverBorderWidth: 15,
                pointRadius: 4,
                data: late,
              },
            ],
          },
          extraOptions: chartConfigs.purpleChartOptions,
          gradientColors: [
            "rgba(37, 67, 117, 0.5)",
            "rgba(37, 67, 117, 0.0)",
            "rgba(37, 67, 117, 0.0)",
            "rgba(255, 3, 2, 0.8)",
            "rgba(255, 3, 2, 0.2)",
            "rgba(255, 3, 2, 0.0)",
          ],
          gradientStops: [1, 0.4, 0, 1, 0.4, 0],
          loaded: false,
        };

        // ################################################################################################# //

        // Storing routes filter
        this.selects.driver = [{ value: "All", label: "All" }];
        for (let i = 0; i < this.driverLogs.length; i++) {
          if (
            CUSTOMER == this.driverLogs[i].CustName &&
            REGION == this.driverLogs[i].RegionName &&
            ROUTE == this.driverLogs[i].RouteName
          ) {
            let record = {};
            record["value"] = this.driverLogs[i].EmpID;
            record["label"] = this.driverLogs[i].EmpID;
            this.selects.driver.push(record);
          }
        }

        // Remove duplicate Driver Name
        this.selects.driver = [
          ...new Set(this.selects.driver.map((itm) => JSON.stringify(itm))),
        ].map((i) => JSON.parse(i));
      } else {
        let scheduleData = [];
        let actualData = [];

        // Store all Customer schedule
        let schedule = [];
        for (let i = 0; i < this.routeLogs.length; i++) {
          if (
            REGION == this.routeLogs[i].RegionName &&
            CUSTOMER == this.routeLogs[i].CustName
          ) {
            schedule.push(this.routeLogs[i].ScheduleData);
          }
        }
        // Calculation for Schedule
        for (let i = 0; i < schedule[0].length; i++) {
          let total = 0;
          for (let j = 0; j < schedule.length; j++) {
            total += schedule[j][i];
          }
          scheduleData.push(total);
        }

        // Store all Customer actual pickup
        let actual = [];
        for (let i = 0; i < this.routeLogs.length; i++) {
          if (
            REGION == this.routeLogs[i].RegionName &&
            CUSTOMER == this.routeLogs[i].CustName
          ) {
            actual.push(this.routeLogs[i].CollectionLog);
          }
        }
        // Calculation for Actual
        for (let i = 0; i < actual[0].length; i++) {
          let total = 0;
          for (let j = 0; j < actual.length; j++) {
            total += parseInt(actual[j][i]);
          }
          actualData.push(total);
        }

        // Marshalling for Performance Perentage
        let percentageData = [];
        for (let i = 0; i < scheduleData.length; i++) {
          let percent = (actualData[i] / scheduleData[i]) * 100;
          percentageData.push(percent.toFixed(2));
        }

        // ################################################################################################# //

        // Customer Punctuality
        let onTime = Array(this.labels.length).fill(0);
        let late = Array(this.labels.length).fill(0);

        for (let i = 0; i < this.routePunctuality.length; i++) {
          if (
            CUSTOMER == this.routePunctuality[i].CustName &&
            REGION == this.routePunctuality[i].RegionName
          ) {
            for (let j = 0; j < this.routePunctuality[i].OnTime.length; j++) {
              onTime[j] += this.routePunctuality[i].OnTime[j];
            }
            for (let j = 0; j < this.routePunctuality[i].Late.length; j++) {
              late[j] += this.routePunctuality[i].Late[j];
            }
          }
        }

        this.collectionPunctuality = {
          chartData: {
            labels: this.labels,
            datasets: [
              {
                label: "On Time",
                fill: true,
                borderColor: "rgba(37, 67, 117, 1)",
                borderWidth: 2,
                borderDash: [],
                borderDashOffset: 0.0,
                pointBackgroundColor: "rgba(37, 67, 117, 1)",
                pointBorderColor: "rgba(255,255,255,0)",
                pointHoverBackgroundColor: "#be55ed",
                pointBorderWidth: 20,
                pointHoverRadius: 4,
                pointHoverBorderWidth: 15,
                pointRadius: 4,
                data: onTime,
              },
              {
                label: "Late",
                fill: true,
                borderColor: "rgba(255, 3, 2, 1)",
                borderWidth: 2,
                borderDash: [],
                borderDashOffset: 0.0,
                pointBackgroundColor: "rgba(255, 3, 2, 1)",
                pointBorderColor: "rgba(255,255,255,0)",
                pointHoverBackgroundColor: "#be55ed",
                pointBorderWidth: 20,
                pointHoverRadius: 4,
                pointHoverBorderWidth: 15,
                pointRadius: 4,
                data: late,
              },
            ],
          },
          extraOptions: chartConfigs.purpleChartOptions,
          gradientColors: [
            "rgba(37, 67, 117, 0.5)",
            "rgba(37, 67, 117, 0.0)",
            "rgba(37, 67, 117, 0.0)",
            "rgba(255, 3, 2, 0.8)",
            "rgba(255, 3, 2, 0.2)",
            "rgba(255, 3, 2, 0.0)",
          ],
          gradientStops: [1, 0.4, 0, 1, 0.4, 0],
          loaded: false,
        };

        // ################################################################################################# //

        // Update Performance Percentage
        this.performancePercentage.chartData.datasets[0].data = percentageData;

        // Update Efficiency Frequency Graph
        this.efficiencyFrequency.chartData.datasets[1].data = scheduleData;
        this.efficiencyFrequency.chartData.datasets[0].data = actualData;

        // Storing regions filter
        this.selects.driver = [{ value: "All", label: "All" }];
        for (let i = 0; i < this.driverLogs.length; i++) {
          let record = {};
          record["value"] = this.driverLogs[i].EmpID;
          record["label"] = this.driverLogs[i].EmpID;
          this.selects.driver.push(record);
        }
        // Remove duplicate Driver Name
        this.selects.driver = [
          ...new Set(this.selects.driver.map((itm) => JSON.stringify(itm))),
        ].map((i) => JSON.parse(i));
      }

      this.selects.selectDriver = "";
      ROUTE == "All"
        ? (this.disableDriver = true)
        : (this.disableDriver = false);
      this.performancePercentage.loaded = true;
      this.efficiencyFrequency.loaded = true;
      this.collectionPunctuality.loaded = true;
    },
    //////////////////////////////////////////////////////// FILTER DRIVER ///////////////////////////////////////////////////////////
    async filterDriver() {
      this.efficiencyFrequency.loaded = false;
      this.performancePercentage.loaded = false;
      this.collectionPunctuality.loaded = false;
      const DRIVER = await this.selects.selectDriver;
      const CUSTOMER = this.selects.selectCustomer;
      const REGION = this.selects.selectRegion;
      const ROUTE = this.selects.selectRoute;

      let scheduleData = [];
      let actualData = [];

      // Store all Driver schedule
      let schedule = [];
      if (DRIVER != "All") {
        for (let i = 0; i < this.driverLogs.length; i++) {
          if (
            CUSTOMER == this.driverLogs[i].CustName &&
            REGION == this.driverLogs[i].RegionName &&
            ROUTE == this.driverLogs[i].RouteName &&
            DRIVER == this.driverLogs[i].EmpID
          ) {
            schedule.push(this.driverLogs[i].ScheduleData);
          }
        }
        // Calculation for Schedule
        for (let i = 0; i < schedule[0].length; i++) {
          let total = 0;
          for (let j = 0; j < schedule.length; j++) {
            total += schedule[j][i];
          }
          scheduleData.push(total);
        }

        // Store all Driver actual pickup
        let actual = [];
        for (let i = 0; i < this.driverLogs.length; i++) {
          if (
            CUSTOMER == this.driverLogs[i].CustName &&
            REGION == this.driverLogs[i].RegionName &&
            ROUTE == this.driverLogs[i].RouteName &&
            DRIVER == this.driverLogs[i].EmpID
          ) {
            actual.push(this.driverLogs[i].CollectionLog);
          }
        }
        // Calculation for Actual
        for (let i = 0; i < actual[0].length; i++) {
          let total = 0;
          for (let j = 0; j < actual.length; j++) {
            total += parseInt(actual[j][i]);
          }
          actualData.push(total);
        }
      } else {
        for (let i = 0; i < this.routeLogs.length; i++) {
          if (
            CUSTOMER == this.routeLogs[i].CustName &&
            REGION == this.routeLogs[i].RegionName &&
            ROUTE == this.routeLogs[i].RouteName
          ) {
            schedule.push(this.routeLogs[i].ScheduleData);
          }
        }
        // Calculation for Schedule
        for (let i = 0; i < schedule[0].length; i++) {
          let total = 0;
          for (let j = 0; j < schedule.length; j++) {
            total += schedule[j][i];
          }
          scheduleData.push(total);
        }
        // Store all Driver actual pickup
        let actual = [];
        for (let i = 0; i < this.routeLogs.length; i++) {
          if (
            CUSTOMER == this.routeLogs[i].CustName &&
            REGION == this.routeLogs[i].RegionName &&
            ROUTE == this.routeLogs[i].RouteName
          ) {
            actual.push(this.routeLogs[i].CollectionLog);
          }
        }
        // Calculation for Actual
        for (let i = 0; i < actual[0].length; i++) {
          let total = 0;
          for (let j = 0; j < actual.length; j++) {
            total += parseInt(actual[j][i]);
          }
          actualData.push(total);
        }
      }

      // Marshalling for Performance Perentage
      let percentageData = [];
      for (let i = 0; i < scheduleData.length; i++) {
        let percent = (actualData[i] / scheduleData[i]) * 100;
        percentageData.push(percent.toFixed(2));
      }

      // ################################################################################################# //

      // Customer Punctuality
      let onTime = Array(this.labels.length).fill(0);
      let late = Array(this.labels.length).fill(0);

      if (DRIVER != "All") {
        for (let i = 0; i < this.driverPunctuality.length; i++) {
          if (
            CUSTOMER == this.driverPunctuality[i].CustName &&
            REGION == this.driverPunctuality[i].RegionName &&
            ROUTE == this.driverPunctuality[i].RouteName &&
            DRIVER == this.driverPunctuality[i].EmpID
          ) {
            for (let j = 0; j < this.driverPunctuality[i].OnTime.length; j++) {
              onTime[j] += this.driverPunctuality[i].OnTime[j];
            }
            for (let j = 0; j < this.driverPunctuality[i].Late.length; j++) {
              late[j] += this.driverPunctuality[i].Late[j];
            }
          }
        }
      } else {
        for (let i = 0; i < this.driverPunctuality.length; i++) {
          if (
            CUSTOMER == this.driverPunctuality[i].CustName &&
            REGION == this.driverPunctuality[i].RegionName &&
            ROUTE == this.driverPunctuality[i].RouteName
          ) {
            for (let j = 0; j < this.driverPunctuality[i].OnTime.length; j++) {
              onTime[j] += this.driverPunctuality[i].OnTime[j];
            }
            for (let j = 0; j < this.driverPunctuality[i].Late.length; j++) {
              late[j] += this.driverPunctuality[i].Late[j];
            }
          }
        }
      }

      this.collectionPunctuality = {
        chartData: {
          labels: this.labels,
          datasets: [
            {
              label: "On Time",
              fill: true,
              borderColor: "rgba(37, 67, 117, 1)",
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              pointBackgroundColor: "rgba(37, 67, 117, 1)",
              pointBorderColor: "rgba(255,255,255,0)",
              pointHoverBackgroundColor: "#be55ed",
              pointBorderWidth: 20,
              pointHoverRadius: 4,
              pointHoverBorderWidth: 15,
              pointRadius: 4,
              data: onTime,
            },
            {
              label: "Late",
              fill: true,
              borderColor: "rgba(255, 3, 2, 1)",
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              pointBackgroundColor: "rgba(255, 3, 2, 1)",
              pointBorderColor: "rgba(255,255,255,0)",
              pointHoverBackgroundColor: "#be55ed",
              pointBorderWidth: 20,
              pointHoverRadius: 4,
              pointHoverBorderWidth: 15,
              pointRadius: 4,
              data: late,
            },
          ],
        },
        extraOptions: chartConfigs.purpleChartOptions,
        gradientColors: [
          "rgba(37, 67, 117, 0.5)",
          "rgba(37, 67, 117, 0.0)",
          "rgba(37, 67, 117, 0.0)",
          "rgba(255, 3, 2, 0.8)",
          "rgba(255, 3, 2, 0.2)",
          "rgba(255, 3, 2, 0.0)",
        ],
        gradientStops: [1, 0.4, 0, 1, 0.4, 0],
        loaded: false,
      };

      // ################################################################################################# //

      // Update Performance Percentage
      this.performancePercentage.chartData.datasets[0].data = percentageData;
      // Update Efficency of Frequency
      this.efficiencyFrequency.chartData.datasets[1].data = scheduleData;
      this.efficiencyFrequency.chartData.datasets[0].data = actualData;

      this.efficiencyFrequency.loaded = true;
      this.performancePercentage.loaded = true;
      this.collectionPunctuality.loaded = true;
    },
    /////////////////////////////////////////////// FILTER FUNCTION /////////////////////////////////////////////////////////////////
    getScheduleActual() {
      this.efficiencyFrequency.loaded = false;
      this.performancePercentage.loaded = false;
      let start = moment(this.selectDate[0]).unix();
      let end = moment(this.selectDate[1]).unix();
      // this.$http.get(":9991/api/v1/analytics/scheduleActual").then(res => {
      this.$http
        .get(`:9991/api/v1/test/schedule-actual/${start}/${end}`)
        .then((res) => {
          if (!res.error) {
            let response = res.message;
            console.log(response);
            this.customerLogs = response.Customer;
            this.regionLogs = response.Region;
            this.routeLogs = response.Route;
            this.driverLogs = response.Driver;

            let scheduleData = [];
            let actualData = [];
            let labels = [];
            let today = moment().weekday();

            // Storing label of the current week
            for (let i = 0; i <= today; i++) {
              labels.push(moment().weekday(i).format("DD MMM"));
            }

            // Store all Customer schedule
            let new_label = [];
            let schedule = [];
            for (let i = 0; i < this.customerLogs.length; i++) {
              schedule.push(this.customerLogs[i].ScheduleData);
              new_label.push(this.customerLogs[i].CreatedAt);
            }
            // Calculation for Schedule
            let new_label2 = [];

            for (let i = 0; i < schedule[0].length; i++) {
              let total = 0;
              for (let j = 0; j < schedule.length; j++) {
                total += schedule[j][i];
                new_label2.push(new_label[j][i]);
              }

              scheduleData.push(total);
            }

            let temp = [];
            for (var i = 0; i < new_label2.length; i++) {
              if (temp.indexOf(new_label2[i]) === -1) {
                temp.push(new_label2[i]);
              }
            }

            for (var i = 0; i < temp.length; i++) {
              temp[i] = moment(temp[i]).format("DD MMM");
            }
            console.log(new_label2);
            console.log(temp);

            // Store all Customer actual pickup
            let actual = [];
            for (let i = 0; i < this.customerLogs.length; i++) {
              actual.push(this.customerLogs[i].CollectionLog);
            }
            // Calculation for Actual
            for (let i = 0; i < actual[0].length; i++) {
              let total = 0;
              for (let j = 0; j < actual.length; j++) {
                total += parseInt(actual[j][i]);
              }
              actualData.push(total);
            }

            this.selects.customer = [{ value: "All", label: "All" }];

            for (let i = 0; i < this.customerLogs.length; i++) {
              let record = {};
              record["value"] = this.customerLogs[i].CustName;
              record["label"] = this.customerLogs[i].CustName;
              this.selects.customer.push(record);
            }

            // Marshalling for Performance Perentage
            let percentageData = [];
            for (let i = 0; i < scheduleData.length; i++) {
              let percent = (actualData[i] / scheduleData[i]) * 100;
              percentageData.push(percent.toFixed(2));
            }

            // Update Efficiency Frequency Graph
            this.efficiencyFrequency = {
              chartData: {
                // labels: labels,
                labels: temp,
                datasets: [
                  {
                    label: "Actual",
                    fill: true,
                    borderColor: "rgba(37, 67, 117, 1)",
                    borderWidth: 2,
                    borderDash: [],
                    borderDashOffset: 0.0,
                    data: actualData,
                  },
                  {
                    type: "line",
                    label: "Schedule",
                    fill: false,
                    borderColor: "rgba(237, 28, 36, 1)",
                    borderWidth: 2,
                    borderDash: [],
                    borderDashOffset: 0.0,
                    pointBackgroundColor: "rgba(237, 28, 36, 1)",
                    pointBorderColor: "rgba(255,255,255,0)",
                    pointHoverBackgroundColor: config.colors.danger,
                    pointBorderWidth: 20,
                    pointHoverRadius: 4,
                    pointHoverBorderWidth: 15,
                    pointRadius: 4,
                    data: scheduleData,
                  },
                ],
              },
              loaded: false,
              extraOptions: chartConfigs.barChartOptionsGradient,
              gradientColors: [
                "rgba(37, 67, 117, 0.9)",
                "rgba(37, 67, 117, 0.3)",
                "rgba(255,255,255, 0)",
              ],
              gradientStops: [1, 0],
            };

            // Update Performance Percentage
            this.performancePercentage = {
              chartData: {
                // labels: labels,
                labels: temp,
                datasets: [
                  {
                    label: "%Number of Pickup",
                    fill: true,
                    borderColor: "rgba(255, 3, 2, 1)",
                    borderWidth: 2,
                    borderDash: [],
                    borderDashOffset: 0.0,
                    data: percentageData,
                  },
                ],
              },
              loaded: false,
              extraOptions: chartConfigs.percentageBarChart,
              gradientColors: [
                "rgba(255, 3, 2, 0.8)",
                "rgba(255, 3, 2, 0.2)",
                "rgba(255, 3, 2, 0.1)",
              ],
              gradientStops: [1, 0],
            };

            this.efficiencyFrequency.loaded = true;
            this.performancePercentage.loaded = true;
          } else {
            // swal({
            //   title: "Data Error!",
            //   text: `${res.message}`,
            //   type: "warning",
            //   confirmButtonClass: "btn btn-success btn-fill",
            //   confirmButtonText: "Okay",
            //   buttonsStyling: false
            // });
            this.defaultChart();
          }
        });
    },
    getTimeSeriesData() {
      const TIME = this.selects.selectTime;
      let myFormat = "ddd MMM D YYYY 00:00:00";

      if (TIME == "Today") {
        let start = moment().format(myFormat) + " GMT+0800 (Malaysia Time)";
        let end = moment().format(myFormat) + " GMT+0800 (Malaysia Time)";
        this.selectDate = [start, end];
        this.getAllDataOnRange();
      } else if (TIME == "Weekly") {
        let start =
          moment().startOf("week").format(myFormat) +
          " GMT+0800 (Malaysia Time)";
        let end = moment().format(myFormat) + " GMT+0800 (Malaysia Time)";
        this.selectDate = [start, end];
        this.getScheduleActual();
        this.collectPunctuality();
      } else if (TIME == "Monthly") {
        let start =
          moment().startOf("month").format(myFormat) +
          " GMT+0800 (Malaysia Time)";
        let end = moment().format(myFormat) + " GMT+0800 (Malaysia Time)";
        this.selectDate = [start, end];
        this.getAllDataOnRange();
      }
    },
    getAllDataOnRange() {
      console.log(this.selectDate);
      this.performancePercentage.loaded = false;
      this.efficiencyFrequency.loaded = false;
      this.collectionPunctuality.loaded = false;

      this.selects.selectCustomer = "";
      this.selects.selectRegion = "";
      this.selects.selectRoute = "";
      this.selects.selectDriver = "";

      let start = moment(this.selectDate[0]).unix();
      let end = moment(this.selectDate[1]).unix();
      let now = moment().unix();

      if (end > now) {
        swal({
          title: "Date Error!",
          text: `Date should be earlier or equal to today's Date`,
          type: "warning",
          confirmButtonClass: "btn btn-success btn-fill",
          confirmButtonText: "Okay",
          buttonsStyling: false,
        });
        this.defaultChart();
      } else {
        end = moment(this.selectDate[1])
          .add(23, "hours")
          .add(59, "minutes")
          .add(59, "seconds")
          .unix();
        console.log(start, end);
      

        this.$http
          .get(`:9991/api/v1/test/schedule-actual/${start}/${end}`)
          // .get(`:9991/api/v1/analytics/scheduleActual/${start}/${end}`)
          .then((res) => {
            console.log(res);
            if (!res.error) {
              let response = res.message;
              this.customerLogs = response.Customer;
              this.regionLogs = response.Region;
              this.routeLogs = response.Route;
              this.driverLogs = response.Driver;
              

              let scheduleData = [];
              let actualData = [];
              let labels = [];
              let labels_1 = [];
              let labels_2 = [];
              let duration = this.customerLogs[0].CollectionLog.length;

              start = moment(this.selectDate[0]).weekday();
              end = moment(this.selectDate[1]).weekday();
              console.log(start, end);
              console.log(duration);

              /////////////// Store day based on the selected date range ///////////////
              // if (duration > 7) {
              // for (let i = start; i < 7; i++) {
              //   let currentDay = moment().weekday(i).format("ddd");
              //   labels_1.push(currentDay);
              //   duration--;
              // }
              // for (let i = 0; i <= end; i++) {
              //   let currentDay = moment().weekday(i).format("ddd");
              //   labels_2.push(currentDay);
              //   duration--;
              // }
              // if (duration != 0) {
              //   let weeksLeft = duration / 7;
              //   for (let i = 0; i < weeksLeft; i++) {
              //     for (let j = 0; j < 7; j++) {
              //       let currentDay = moment().weekday(j).format("ddd");
              //       labels_1.push(currentDay);
              //     }
              //   }
              // }
              // labels = labels_1.concat(labels_2);
              // for (var i = 0; i < duration; i++) {
              //   let tarikh = i + 1;
              //   labels.push(
              //     tarikh + " " + moment(this.selectDate[0]).format("MMM")
              //   );
              // }
              // } else {
              //   if (start == 0) {
              //     for (let i = start; i <= end; i++) {
              //       let currentDay = moment().weekday(i).format("DD MMM");
              //       labels.push(currentDay);
              //     }
              //   } else if (start < end && start != 0) {
              //     for (let i = start; i <= end; i++) {
              //       let currentDay = moment().weekday(i).format("DD MMM");
              //       labels.push(currentDay);
              //     }
              //   } else if (start > end) {
              //     for (let i = start; i < 7; i++) {
              //       let currentDay = moment().weekday(i).format("DD MMM");
              //       labels.push(currentDay);
              //     }
              //     for (let i = 0; i <= end; i++) {
              //       let currentDay = moment().weekday(i).format("DD MMM");
              //       labels.push(currentDay);
              //     }
              //   } else if (start == end) {
              //     let currentDay = moment().weekday(start).format("DD MMM");
              //     labels.push(currentDay);
              //   }
              // }

              /////////////// Store day based on the selected date range ///////////////

              // Store all Customer schedule
              let new_label = [];
              let schedule = [];
              for (let i = 0; i < this.customerLogs.length; i++) {
                
                schedule.push(this.customerLogs[i].ScheduleData);
                new_label.push(this.customerLogs[i].CreatedAt);
              }

              let new_label2 = [];
              // console.log(schedule)
              // console.log(new_label)
              for (let i = 0; i < schedule[0].length; i++) {
                let total = 0;
                for (let j = 0; j < schedule.length; j++) {
                  total += schedule[j][i];
                }
                scheduleData.push(total);
              }

              // console.log(new_label.length)
              for(var i=0;i<new_label.length; i++){
                // console.log(new_label[i])
                for(var j=0; j<new_label[i].length; j++){
                  // console.log(new_label[i][j])
                  new_label2.push(new_label[i][j]);
                }
              }

              let temp = [];
              // console.log(new_label2)
              for (var i = 0; i < new_label2.length; i++) {
                if (temp.indexOf(new_label2[i]) === -1) {
                  temp.push(new_label2[i]);
                }
              }

              for (var i = 0; i < temp.length; i++) {
                temp[i] = moment(temp[i]).format("DD MMM");
              }

              // console.log(temp);
              let sortedArray = temp.sort(function (a, b) {
                const date1 = new Date(a);
                const date2 = new Date(b);

                return date1 - date2;
              });
              // console.log(sortedArray);

              // Store all Customer actual pickup
              let actual = [];
              for (let i = 0; i < this.customerLogs.length; i++) {
                actual.push(this.customerLogs[i].CollectionLog);
              }
              for (let i = 0; i < actual[0].length; i++) {
                let total = 0;
                for (let j = 0; j < actual.length; j++) {
                  total += parseInt(actual[j][i]);
                }
                actualData.push(total);
              }
              this.selects.customer = [{ value: "All", label: "All" }];
              this.selects.selectCustomer = "All";
              this.selects.selectRegion = "";
              this.disableRegion = true;
              for (let i = 0; i < this.customerLogs.length; i++) {
                let record = {};
                record["value"] = this.customerLogs[i].CustName;
                record["label"] = this.customerLogs[i].CustName;
                this.selects.customer.push(record);
              }

              // Marshalling for Performance Perentage
              let percentageData = [];
              for (let i = 0; i < scheduleData.length; i++) {
                let percent = (actualData[i] / scheduleData[i]) * 100;
                percentageData.push(percent.toFixed(2));
              }

              // Update Performance Percentage
              this.performancePercentage.chartData.datasets[0].data =
                percentageData;
              // this.performancePercentage.chartData.labels = labels;
              this.performancePercentage.chartData.labels = sortedArray;
              this.performancePercentage.loaded = true;

              // Update Efficiency Frequency Graph
              this.efficiencyFrequency.chartData.datasets[1].data =
                scheduleData;
              this.efficiencyFrequency.chartData.datasets[0].data = actualData;
              // this.efficiencyFrequency.chartData.labels = labels;
              this.efficiencyFrequency.chartData.labels = sortedArray;
              this.efficiencyFrequency.loaded = true;
            } else {
              // swal({
              //   title: "Data Error!",
              //   text: `${res.message}`,
              //   type: "warning",
              //   confirmButtonClass: "btn btn-success btn-fill",
              //   confirmButtonText: "Okay",
              //   buttonsStyling: false
              // });
              this.defaultChart();
            }
          });

        start = moment(this.selectDate[0]).unix();
        end = moment(this.selectDate[1]).unix();

        end = moment(this.selectDate[1])
          .add(23, "hours")
          .add(59, "minutes")
          .add(59, "seconds")
          .unix();

        this.$http
          .get(`:9991/api/v1/test/punc/${start}/${end}`)
          // .get(`:9991/api/v1/analytics/punctual/${start}/${end}`)
          .then((res) => {
            if (!res.error) {
              this.custPunctuality = res.message.Customer;
              this.regionPunctuality = res.message.Region;
              this.routePunctuality = res.message.Route;
              this.driverPunctuality = res.message.Driver;

              start = moment(this.selectDate[0]).weekday();
              end = moment(this.selectDate[1]).weekday();

              let labels = [];
              let labels_1 = [];
              let labels_2 = [];
              let duration = this.custPunctuality[0].OnTime.length;

              /////////////// Store day based on the selected date range ///////////////
              // if (duration > 7) {
                // for (let i = start; i < 7; i++) {
                //   let currentDay = moment().weekday(i).format("ddd");
                //   labels_1.push(currentDay);
                //   duration--;
                // }
                // for (let i = 0; i <= end; i++) {
                //   let currentDay = moment().weekday(i).format("ddd");
                //   labels_2.push(currentDay);
                //   duration--;
                // }
                // if (duration != 0) {
                //   let weeksLeft = duration / 7;
                //   for (let i = 0; i < weeksLeft; i++) {
                //     for (let j = 0; j < 7; j++) {
                //       let currentDay = moment().weekday(j).format("ddd");
                //       labels_1.push(currentDay);
                //     }
                //   }
                // }
                // labels = labels_1.concat(labels_2);
                // for (var i = 0; i < duration; i++) {
                //   let tarikh = i + 1;
                //   labels.push(
                //     tarikh + " " + moment(this.selectDate[0]).format("MMM")
                //   );
                // }
              // } else {
              //   if (start == 0) {
              //     for (let i = start; i <= end; i++) {
              //       let currentDay = moment().weekday(i).format("DD MMM");
              //       labels.push(currentDay);
              //     }
              //   } else if (start < end && start != 0) {
              //     for (let i = start; i <= end; i++) {
              //       let currentDay = moment().weekday(i).format("DD MMM");
              //       labels.push(currentDay);
              //     }
              //   } else if (start > end) {
              //     for (let i = start; i < 7; i++) {
              //       let currentDay = moment().weekday(i).format("DD MMM");
              //       labels.push(currentDay);
              //     }
              //     for (let i = 0; i <= end; i++) {
              //       let currentDay = moment().weekday(i).format("DD MMM");
              //       labels.push(currentDay);
              //     }
              //   } else if (start == end) {
              //     let currentDay = moment().weekday(start).format("DD MMM");
              //     labels.push(currentDay);
              //   }
              // }

              console.log(this.custPunctuality)
              // assign label
              // let new_labell = []
              // for (let i = 0; i < this.custPunctuality.length; i++) {
              //   for (
              //     let j = 0;
              //     j < this.custPunctuality[i].CreatedAt.length;
              //     j++
              //   ) {
              //     new_labell.push(this.custPunctuality[i].CreatedAt[j])
              //   }
              // }

             

              // let temp2 = [];
              // console.log(new_labell)
              // for (var i = 0; i < new_labell.length; i++) {
              //   if (temp2.indexOf(new_labell[i]) === -1) {
              //     temp2.push(new_labell[i]);
              //   }
              // }

              // for (var i = 0; i < temp2.length; i++) {
              //   temp2[i] = moment(temp2[i]).format("DD MMM");
              // }

              // // console.log(temp);
              // let sortedArray2 = temp2.sort(function (a, b) {
              //   const date1 = new Date(a);
              //   const date2 = new Date(b);

              //   return date1 - date2;
              // });

              let new_labell = []

              for (let i = 0; i < this.custPunctuality.length; i++) {
                for (
                  let j = 0;
                  j < this.custPunctuality[i].OnTime.length;
                  j++
                ) {
                  
                  new_labell.push(this.custPunctuality[i].CreatedAt)
                }
              }

               let new_labell2 = []
              for(var i=0;i<new_labell.length; i++){
                
                for(var j=0; j<new_labell[i].length; j++){
                  
                  new_labell2.push(new_labell[i][j]);
                }
              }
              console.log(new_labell2)

              let temp2 = [];
              
              for (var i = 0; i < new_labell2.length; i++) {
                if (temp2.indexOf(new_labell2[i]) === -1) {
                  temp2.push(new_labell2[i]);
                }
              }

              for (var i = 0; i < temp2.length; i++) {
                temp2[i] = moment(temp2[i]).format("DD MMM");
              }

              
              let sortedArray2 = temp2.sort(function (a, b) {
                const date1 = new Date(a);
                const date2 = new Date(b);

                return date1 - date2;
              });

              console.log(sortedArray2)


              
              let onTime = Array(sortedArray2.length).fill(0);
              let late = Array(sortedArray2.length).fill(0);
              // let new_labell = []

              for (let i = 0; i < this.custPunctuality.length; i++) {
                for (
                  let j = 0;
                  j < this.custPunctuality[i].OnTime.length;
                  j++
                ) {
                  onTime[j] += this.custPunctuality[i].OnTime[j];
                  new_labell.push(this.custPunctuality[i].CreatedAt)
                }
                for (let j = 0; j < this.custPunctuality[i].Late.length; j++) {
                  late[j] += this.custPunctuality[i].Late[j];
                }
              }
              console.log(new_labell)
              console.log(onTime)
              console.log(late)
               
             
             

              this.collectionPunctuality = {
                chartData: {
                  labels: sortedArray2,
                  datasets: [
                    {
                      label: "On Time",
                      fill: true,
                      borderColor: "rgba(37, 67, 117, 1)",
                      borderWidth: 2,
                      borderDash: [],
                      borderDashOffset: 0.0,
                      pointBackgroundColor: "rgba(37, 67, 117, 1)",
                      pointBorderColor: "rgba(255,255,255,0)",
                      pointHoverBackgroundColor: "#be55ed",
                      pointBorderWidth: 20,
                      pointHoverRadius: 4,
                      pointHoverBorderWidth: 15,
                      pointRadius: 4,
                      data: onTime,
                    },
                    {
                      label: "Late",
                      fill: true,
                      borderColor: "rgba(255, 3, 2, 1)",
                      borderWidth: 2,
                      borderDash: [],
                      borderDashOffset: 0.0,
                      pointBackgroundColor: "rgba(255, 3, 2, 1)",
                      pointBorderColor: "rgba(255,255,255,0)",
                      pointHoverBackgroundColor: "#be55ed",
                      pointBorderWidth: 20,
                      pointHoverRadius: 4,
                      pointHoverBorderWidth: 15,
                      pointRadius: 4,
                      data: late,
                    },
                  ],
                },
                extraOptions: chartConfigs.purpleChartOptions,
                gradientColors: [
                  "rgba(37, 67, 117, 0.5)",
                  "rgba(37, 67, 117, 0.0)",
                  "rgba(37, 67, 117, 0.0)",
                  "rgba(255, 3, 2, 0.8)",
                  "rgba(255, 3, 2, 0.2)",
                  "rgba(255, 3, 2, 0.0)",
                ],
                gradientStops: [1, 0.4, 0, 1, 0.4, 0],
                loaded: false,
              };

              // ################################################################################################# //

              this.labels = sortedArray2;
              this.collectionPunctuality.loaded = true;
            } else {
              this.defaultChart();
            }
          });

        this.disableRegion = true;
        this.disableRoute = true;
        this.disableDriver = true;
      }
    },
    collectPunctuality() {
      this.collectionPunctuality.loaded = false;
      let start = moment(this.selectDate[0]).unix();
      let end = moment(this.selectDate[1]).unix();
      console.log("masul");
      // this.$http.get(":9991/api/v1/analytics/punctual").then((res) => {
      this.$http.get(`:9991/api/v1/test/punc/${start}/${end}`).then((res) => {
        if (!res.error) {
          this.custPunctuality = res.message.Customer;
          this.regionPunctuality = res.message.Region;
          this.routePunctuality = res.message.Route;
          this.driverPunctuality = res.message.Driver;

          let labels = [];
          let today = moment().weekday();

          // Storing label of the current week
          for (let i = 0; i <= today; i++) {
            labels.push(moment().weekday(i).format("DD MMM"));
          }

          let onTime = Array(today + 1).fill(0);
          let late = Array(today + 1).fill(0);

          for (let i = 0; i < this.custPunctuality.length; i++) {
            for (let j = 0; j < this.custPunctuality[i].OnTime.length; j++) {
              onTime[j] += this.custPunctuality[i].OnTime[j];
            }
            for (let j = 0; j < this.custPunctuality[i].Late.length; j++) {
              late[j] += this.custPunctuality[i].Late[j];
            }
          }

          this.collectionPunctuality = {
            chartData: {
              labels: labels,
              datasets: [
                {
                  label: "On Time",
                  fill: true,
                  borderColor: "rgba(37, 67, 117, 1)",
                  borderWidth: 2,
                  borderDash: [],
                  borderDashOffset: 0.0,
                  pointBackgroundColor: "rgba(37, 67, 117, 1)",
                  pointBorderColor: "rgba(255,255,255,0)",
                  pointHoverBackgroundColor: "#be55ed",
                  pointBorderWidth: 20,
                  pointHoverRadius: 4,
                  pointHoverBorderWidth: 15,
                  pointRadius: 4,
                  data: onTime,
                },
                {
                  label: "Late",
                  fill: true,
                  borderColor: "rgba(255, 3, 2, 1)",
                  borderWidth: 2,
                  borderDash: [],
                  borderDashOffset: 0.0,
                  pointBackgroundColor: "rgba(255, 3, 2, 1)",
                  pointBorderColor: "rgba(255,255,255,0)",
                  pointHoverBackgroundColor: "#be55ed",
                  pointBorderWidth: 20,
                  pointHoverRadius: 4,
                  pointHoverBorderWidth: 15,
                  pointRadius: 4,
                  data: late,
                },
              ],
            },
            extraOptions: chartConfigs.purpleChartOptions,
            gradientColors: [
              "rgba(37, 67, 117, 0.5)",
              "rgba(37, 67, 117, 0.0)",
              "rgba(37, 67, 117, 0.0)",
              "rgba(255, 3, 2, 0.8)",
              "rgba(255, 3, 2, 0.2)",
              "rgba(255, 3, 2, 0.0)",
            ],
            gradientStops: [1, 0.4, 0, 1, 0.4, 0],
            loaded: false,
          };

          this.labels = labels;
          this.collectionPunctuality.loaded = true;
        }
      });
    },
    async defaultChart() {
      this.collectionPunctuality = await {
        chartData: {
          labels: ["MON", "TUE", "WED", "THU", "FRI", "SAT", "SUN"],
          datasets: [
            {
              label: "On Time",
              fill: true,
              borderColor: "rgba(37, 67, 117, 1)",
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              pointBackgroundColor: "rgba(37, 67, 117, 1)",
              pointBorderColor: "rgba(255,255,255,0)",
              pointHoverBackgroundColor: "#be55ed",
              pointBorderWidth: 20,
              pointHoverRadius: 4,
              pointHoverBorderWidth: 15,
              pointRadius: 4,
              data: Array(7).fill(0),
            },
            {
              label: "Late",
              fill: true,
              borderColor: "rgba(255, 3, 2, 1)",
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              pointBackgroundColor: "rgba(255, 3, 2, 1)",
              pointBorderColor: "rgba(255,255,255,0)",
              pointHoverBackgroundColor: "#be55ed",
              pointBorderWidth: 20,
              pointHoverRadius: 4,
              pointHoverBorderWidth: 15,
              pointRadius: 4,
              data: Array(7).fill(0),
            },
          ],
        },
        extraOptions: chartConfigs.purpleChartOptions,
        gradientColors: [
          "rgba(37, 67, 117, 0.5)",
          "rgba(37, 67, 117, 0.0)",
          "rgba(37, 67, 117, 0.0)",
          "rgba(255, 3, 2, 0.8)",
          "rgba(255, 3, 2, 0.2)",
          "rgba(255, 3, 2, 0.0)",
        ],
        gradientStops: [1, 0.4, 0, 1, 0.4, 0],
        loaded: false,
      };

      this.efficiencyFrequency = {
        chartData: {
          labels: ["MON", "TUE", "WED", "THU", "FRI", "SAT", "SUN"],
          datasets: [
            {
              label: "Actual",
              fill: true,
              borderColor: "rgba(37, 67, 117, 1)",
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              data: Array(7).fill(0),
            },
            {
              type: "line",
              label: "Schedule",
              fill: false,
              borderColor: "rgba(237, 28, 36, 1)",
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              pointBackgroundColor: "rgba(237, 28, 36, 1)",
              pointBorderColor: "rgba(255,255,255,0)",
              pointHoverBackgroundColor: config.colors.danger,
              pointBorderWidth: 20,
              pointHoverRadius: 4,
              pointHoverBorderWidth: 15,
              pointRadius: 4,
              data: Array(7).fill(0),
            },
          ],
        },
        loaded: false,
        extraOptions: chartConfigs.barChartOptionsGradient,
        gradientColors: [
          "rgba(37, 67, 117, 0.9)",
          "rgba(37, 67, 117, 0.3)",
          "rgba(255,255,255, 0)",
        ],
        gradientStops: [1, 0],
      };

      this.performancePercentage = {
        chartData: {
          labels: ["MON", "TUE", "WED", "THU", "FRI", "SAT", "SUN"],
          datasets: [
            {
              label: "%Number of Pickup",
              fill: true,
              borderColor: "rgba(255, 3, 2, 1)",
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              data: Array(7).fill(0),
            },
          ],
        },
        loaded: false,
        extraOptions: chartConfigs.percentageBarChart,
        gradientColors: [
          "rgba(255, 3, 2, 0.8)",
          "rgba(255, 3, 2, 0.2)",
          "rgba(255, 3, 2, 0.1)",
        ],
        gradientStops: [1, 0],
      };

      this.selects.customer = [{ value: "All", label: "All" }];
      this.selects.region = [{ value: "All", label: "All" }];
      this.selects.route = [{ value: "All", label: "All" }];
      this.selects.driver = [{ value: "All", label: "All" }];

      this.customerLogs = null;
      this.regionLogs = null;
      this.routeLogs = null;
      this.driverLogs = null;

      this.efficiencyFrequency.loaded = true;
      this.performancePercentage.loaded = true;
      this.collectionPunctuality.loaded = true;
    },
    customerRating() {
      let arr1 = [];
      this.$http.get(`:9991/api/v1/analytics/rating`).then((res) => {
        let response = res.message;
        this.rating = response;

        // initial customer rating data
        var SumStar1 = 0;
        var SumStar2 = 0;
        var SumStar3 = 0;
        var SumStar4 = 0;
        var SumStar5 = 0;

        for (var i = 0; i < this.rating.length; i++) {
          SumStar1 += Number(this.rating[i].Star1);
          SumStar2 += Number(this.rating[i].Star2);
          SumStar3 += Number(this.rating[i].Star3);
          SumStar4 += Number(this.rating[i].Star4);
          SumStar5 += Number(this.rating[i].Star5);

          arr1 = [SumStar1, SumStar2, SumStar3, SumStar4, SumStar5];
          this.barChart2.chartData.datasets[0].data = arr1;
        }
        this.barChart2.loaded = true;
      });
    },
  },

  created() {
    moment.updateLocale("en", {
      week: {
        dow: 1,
      },
    });
    this.selects.selectCustomer = this.selects.customer[0].value;
    this.selects.selectTime = this.selects.timeSeries[1].value;
    let myFormat = "ddd MMM D YYYY 00:00:00";
    let start =
      moment().startOf("week").format(myFormat) + " GMT+0800 (Malaysia Time)";
    let end = moment().format(myFormat) + " GMT+0800 (Malaysia Time)";
    this.selectDate = [start, end];
    this.getScheduleActual();
    this.customerRating();
    this.collectPunctuality();
  },
};
</script>
<style lang="scss" scoped>
.inline {
  margin-top: 1.5%;
}
hr {
  color: black;
  margin-top: 0%;
}
.select-width {
  max-width: 50%;
}
.spinner {
  margin: 12%;
}
</style>